module.exports = __webpack_public_path__ + "img/hjx_login_bg.34dd7c5b.png";